<template>
  <div class="button-options" role="group">
    <button class="btn btn-secondary btn-sm"
            v-if="canUpdate(access) && hideEdit === false"
            :disabled="isRefreshed || isSubmit || isLoading"
            @click="onEditClicked">
      <i class="ri-edit-box-line"></i>
      Edit
    </button>
    <router-link v-if="canRead(access) && hideDetail === false && viewTo"
            class="btn btn-outline-primary btn-sm"
            :class="{ disabled: isRefreshed || isSubmit || isLoading }"
            :to="viewTo">
      <i class="ri-information-line"></i>
      Detail
    </router-link>
    <button class="btn btn-outline-primary btn-sm"
            v-else-if="canRead(access) && hideDetail === false"
            :disabled="isRefreshed || isSubmit || isLoading"
            @click="onViewClicked">
      <i class="ri-information-line"></i>
      Detail
    </button>
    <button class="btn btn-secondary btn-sm"
            v-if="canCreate(access) && hideDuplicate === false"
            :disabled="isRefreshed || isSubmit || isLoading"
            @click="onDuplicateClicked">
      <i class="ri-file-copy-line"></i>
      Duplicate
    </button>
    <button class="btn btn-outline-primary btn-sm"
            v-if="isAnalyticsEnabled"
            :disabled="isRefreshed || isSubmit || isLoading"
            @click="onAnalyticsClicked">
      <i class="ri-bar-chart-2-line"></i>
      Analytics
    </button>
    <button class="btn btn-ghost-danger btn-sm"
            v-if="canDelete(access) && hideDelete === false"
            :disabled="isRefreshed || isSubmit || isLoading"
            @click="onDeleteClicked">
      <i class="ri-delete-bin-7-line"></i>
      Delete
    </button>
    <button class="btn btn-secondary btn-sm"
            v-if="isBackEnabled"
            :disabled="isRefreshed || isSubmit || isLoading"
            @click="onBackClicked">
      <i class="ri-arrow-go-back-line"></i>
      Back
    </button>
    <button class="btn btn-primary btn-sm"
            v-if="canCreate(access) && hideAdd === false"
            :disabled="isRefreshed || isSubmit || isLoading"
            @click="onAddItemClicked">
      <i class="ri-add-line"></i>
      Add
    </button>
    <button class="btn btn-secondary btn-sm"
            v-if="isRefreshEnabled"
            :disabled="isRefreshed || isSubmit || isLoading"
            @click="onRefreshed">
      <wave-loader v-if="isRefreshed" size="sm" mono />
      <i v-else class="fa ri-refresh-line"></i>
      Refresh
    </button>
    <button class="btn btn-primary btn-sm"
            v-if="isSaveEnabled"
            :disabled="isRefreshed || isSubmit || isLoading"
            @click="onSubmit">
      <wave-loader v-if="isSubmit" size="sm" mono />
      <i v-else class="fa ri-save-line"></i>
      Save
    </button>
  </div>
</template>

<script>
export default {
  name: 'button-options',
  props: ['access',
    'hideEdit',
    'hideDelete',
    'hideAdd',
    'hideDetail',
    'hideDuplicate',
    'isAnalyticsEnabled',
    'isBackEnabled',
    'isSaveEnabled',
    'isRefreshEnabled',
    'options',
    'isRefreshed',
    'isSubmit',
    'isLoading',
    'viewTo'],
  methods: {
    onAddItemClicked() {
      this.$emit('onAddItemClicked');
    },
    onAnalyticsClicked() {
      this.$emit('onAnalyticsClicked');
    },
    onBackClicked() {
      this.$router.back();
    },
    onDeleteClicked() {
      this.$emit('onDeleteClicked');
    },
    onDuplicateClicked() {
      this.$emit('onDuplicateClicked');
    },
    onEditClicked() {
      this.$emit('onEditClicked');
    },
    onRefreshed() {
      this.$emit('onRefreshed');
    },
    onSubmit() {
      this.$emit('onSubmit');
    },
    onViewClicked() {
      this.$emit('onViewClicked');
    },
  },
};
</script>

<style scoped>
/* jarak antar tombol, bukan grup nempel */
.button-options {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: var(--mz-space-2);
}
</style>
